import { Asset, AssetFile, AssetSummary } from '@/lib/assets/types'
import { MarketplaceAssetPurchaseContextItem } from '@/lib/marketplace/types'

type MarketplaceActionAsset = Pick<Asset | AssetSummary, 'level' | 'uuid'>
type MarketplaceActionFile = Pick<AssetFile, 'level'>

interface MarketplaceAssetActionStateParams {
  asset: MarketplaceActionAsset
  context?: MarketplaceAssetPurchaseContextItem | null
  file?: MarketplaceActionFile | null
  isInCart?: boolean
  userCanDownloadPremiumAssets?: boolean
  marketplaceCartEnabled?: boolean | null
}

export function isFreeAsset(asset: MarketplaceActionAsset) {
  const level = Number(asset.level)
  return Number.isFinite(level) ? level <= 0 : false
}

export function isFreeAssetFile(file?: MarketplaceActionFile | null) {
  if (!file) {
    return false
  }

  const level = Number(file.level)
  return Number.isFinite(level) ? level <= 0 : false
}

export function canDownloadAssetDirectly({
  asset,
  context,
  file,
  userCanDownloadPremiumAssets = false,
  marketplaceCartEnabled,
}: MarketplaceAssetActionStateParams) {
  if (marketplaceCartEnabled === false) {
    return true
  }

  if (userCanDownloadPremiumAssets || context?.owned) {
    return true
  }

  if (isFreeAssetFile(file)) {
    return true
  }

  if (context?.purchasable && context.default_price) {
    return false
  }

  return isFreeAsset(asset)
}

export function canShowMarketplaceAssetCartAction({
  asset,
  context,
  file,
  isInCart = false,
  userCanDownloadPremiumAssets = false,
}: MarketplaceAssetActionStateParams) {
  if (!asset.uuid || !context || isFreeAsset(asset)) {
    return false
  }

  if (canDownloadAssetDirectly({ asset, context, file, userCanDownloadPremiumAssets })) {
    return false
  }

  if (!context.purchasable || !context.default_price) {
    return false
  }

  return isInCart || Boolean(context.can_add_to_cart)
}
